import { Box, Skeleton } from '@factorialco/deprecated-design-system'

export const FinanceWidgetStripSkeleton = ({ numElements }: { numElements: number }) => {
  return (
    <Box flexDirection="row" maxWidth="full" justifyContent="flexStart" gap="s16" overflowX="auto">
      {Array(numElements)
        .fill(null)
        .map((_, index) => {
          return (
            <Box
              key={index}
              paddingX={'s12'}
              paddingY={'s16'}
              border={{ all: { color: 'grey200', style: 'solid', width: 's1' } }}
              borderRadius={{ all: 'abs016' }}
              width="full"
              minHeight="s80"
            >
              <Box paddingBottom="s12">
                <Skeleton height="s12" width="s120" />
              </Box>
              <Skeleton height="s12" width="s80" />
            </Box>
          )
        })}
    </Box>
  )
}
